"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNegateEmpty = exports.isFunction = exports.isEmptyObject = exports.isUndefinedOrNull = exports.isUndefined = exports.isBoolean = exports.isNumber = exports.isObject = exports.isString = exports.isArray = void 0;
const global_1 = require("./global");
function isArray(array) {
    return Array.isArray(array);
}
exports.isArray = isArray;
function isString(str) {
    return (typeof str === 'string');
}
exports.isString = isString;
function isObject(obj) {
    return typeof obj === 'object'
        && obj !== null
        && !Array.isArray(obj)
        && !(obj instanceof RegExp)
        && !(obj instanceof Date);
}
exports.isObject = isObject;
function isNumber(obj) {
    return (typeof obj === 'number' && !isNaN(obj));
}
exports.isNumber = isNumber;
function isBoolean(obj) {
    return (obj === true || obj === false);
}
exports.isBoolean = isBoolean;
function isUndefined(obj) {
    return (typeof obj === 'undefined');
}
exports.isUndefined = isUndefined;
function isUndefinedOrNull(obj) {
    return (isUndefined(obj) || obj === null);
}
exports.isUndefinedOrNull = isUndefinedOrNull;
function isEmptyObject(obj) {
    if (!isObject(obj)) {
        return false;
    }
    for (let key in obj) {
        if (global_1.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
exports.isEmptyObject = isEmptyObject;
function isFunction(obj) {
    return (typeof obj === 'function');
}
exports.isFunction = isFunction;
function isNegateEmpty(obj) {
    return !obj && obj !== 0 && obj !== false;
}
exports.isNegateEmpty = isNegateEmpty;
